const OverView = () => {
  return (
    <div className="flex flex-col-reverse md:flex-row md:mx-52 text-white my-10">
      <div className="flex w-1/2 md:mr-6 mx-auto md:mx-0">
        <img
          className=" rounded-3xl"
          src={require("../../assets/images/machineSmall.png")}
          alt="Factory"
        />
      </div>
      <div className="flex flex-col w-full md:w-1/2 md:ml-10 text-left justify-center pb-2">
        <div className="md:h-1/3 text-3xl md:text-5xl font-HNmed mx-7 mb-7 md:mx-0 md:mb-0">
          Company
          <br />{" "}
          <span className="text-[#00B4AE] underline decoration-[#D9A900] underline-offset-8 decoration-2">
            Overview
          </span>
        </div>
        <div className="text-[#ffffffad] text-justify font-HNlight tracking-normal md:text-lg px-10 md:px-0">
          <strong>V Group Industries</strong> has been a pioneer in the
          packaging industry since 1985. Founded by K T Varghese, the company
          began as a factory producing plastic granules from recycled plastics.
          Over the years, V Group Industries expanded its operations to include
          manufacturing plastic bottles and bottle caps, becoming a leader in
          the sector. Renowned for its innovation and commitment to
          sustainability, the company procures the best technology available
          globally to manufacture high-quality products. V Group Industries
          encompasses V Pack, Visa Polymers, Variety Plastics and Vividh
          Plastics.
        </div>
      </div>
    </div>
  );
};
export default OverView;
